"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyFullNameFieldValue = exports.fullNameFields = exports.FullNameDefaultTitles = void 0;
exports.FullNameDefaultTitles = {
    mr: "1",
    mrs: "2",
};
exports.fullNameFields = [
    "title",
    "first_name",
    "middle_name",
    "last_name",
];
exports.emptyFullNameFieldValue = {
    title: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    sys_root: "",
};
